import React, { useState } from "react";
import ExportSettings from "./ExportSettings";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import BuildIcon from "@mui/icons-material/Build";
import SettingsIcon from "@mui/icons-material/Settings";
import InputIcon from "@mui/icons-material/Input";
import ImageIcon from "@mui/icons-material/Image";
import SchoolIcon from "@mui/icons-material/School";
import Branding from "./Branding";
import VideoSettings from "./VideoSettings";
import Testimonials from "./Testimonials";
import VideosPage from "./VideosPage";

const options = [
    {
        key: "Videos",
        label: "Videos",
        icon: <VideoLibraryIcon fontSize="medium" />,
    },
    {
        key: "Testimonials",
        label: "Testimonials",
        icon: <SchoolIcon fontSize="medium" />,
    },
    {
        key: "Branding",
        label: "Branding",
        icon: <ImageIcon fontSize="medium" />,
    },
    {
        key: "Video Settings",
        label: "Video Settings",
        icon: <SettingsIcon fontSize="medium" />,
    },
    {
        key: "Export Settings",
        label: "Export Settings",
        icon: <InputIcon fontSize="medium" />,
    },
];

const VideoWorkshop = () => {
    const [selected, setSelected] = useState("Videos");

    const renderContent = () => {
        switch (selected) {
            case "Videos":
                return <VideosPage />;
            case "Testimonials":
                return <Testimonials />;
            case "Video Settings":
                return <VideoSettings />;
            case "Branding":
                return <Branding />;
            case "Export Settings":
                return <ExportSettings />;
            default:
                return null;
        }
    };

    return (
        <div className="h-screen flex bg-gray-50 text-gray-900">
            <aside className="w-64 bg-[#4880FF] p-6">
                <h2 className="text-2xl font-semibold text-white mb-8 font-[Outfit]">
                    Video Workshop
                </h2>
                <ul className="space-y-4">
                    {options.map((opt) => (
                        <li
                            key={opt.key}
                            onClick={() => setSelected(opt.key)}
                            className={`flex items-center gap-3 px-3 py-2 rounded text-lg font-semibold font-[Outfit] cursor-pointer transition duration-300 ${
                                selected === opt.key
                                    ? "bg-white text-[#4880FF]"
                                    : "text-white hover:bg-white hover:text-[#4880FF]"
                            }`}
                        >
                            {opt.icon}
                            {opt.label}
                        </li>
                    ))}
                </ul>
            </aside>
            <main className="flex-1 p-10 animate-fade-in h-screen overflow-auto">
                <h1 className="text-3xl font-bold text-[#4880FF] mb-4 capitalize font-[Outfit]">
                    {selected}
                </h1>
                <div className="text-lg text-gray-700 font-[Outfit]">
                    {renderContent()}
                </div>
            </main>
        </div>
    );
};

export default VideoWorkshop;
